<template>
<v-card outlined v-bind='cardAttrs' >
  <v-card-title v-if='title' class='overline' v-text='title' />
  <v-form @submit.prevent='addRow(item)'>
    <v-row class='pl-3' >
      <template v-for='(field) in headers' >
        <v-col
          v-if='field.value !== "actions"'
          :key='field.value' >
          <v-text-field
            :id='`field-${field.value}`'
            v-model='item[field.value]'
            v-bind='field.attrs'
            :label='field.text' />
        </v-col>
      </template>
      <v-col >
        <v-btn type='submit' small outlined class='mt-5' >Add</v-btn>
      </v-col>
    </v-row>
  </v-form>

  <v-data-table dense hide-default-footer
    :headers="headers"
    :items-per-page='items.length'
    :items="items" >
    <template v-slot:header.actions >
      <v-btn icon small disabled >
        <v-icon x-small >mdi-delete</v-icon>
      </v-btn>
    </template>

    <template v-slot:body="{ items }" >
        <tbody>
          <tr
            v-for="(item, index) in items" :key="index"
            @click='setValues(item)' >
            <td v-for='field in headers' :key="field.value" >
              {{ item[field.value] }}
            </td>
            <td v-if='withDelete' >
              <v-btn @click='delRow(index)' icon small >
                <v-icon x-small >mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>

    <template v-if='hint' v-slot:footer >
      <v-footer class='caption'>{{hint}}</v-footer>
    </template>
  </v-data-table>
  <v-card-actions v-if='withSaveBtn' >
    <v-spacer />
    <v-btn color='primary' >Save</v-btn>
  </v-card-actions>
</v-card>
</template>
<script>
export default {
  name: 'TableField',
  props: {
    value: { type: Array, default: () => { return [] }},
    headers: {type: Array, required: true },
    title: { type: String, required: false },
    hint: { type: String, required: false },
    withSaveBtn: { type: Boolean, default: false },
    withDelete: { type: Boolean, default: true },
    cardAttrs: { type: Object, default: () => {} }
  },
  data () {
    return {
      item: {},
      items: []
    }
  },
  watch: {
    value: {
      immediate: true,
      handler () {
        if (this.value) {
          this.items = this.value
        } else {
          this.items = []
        }
      }
    }
  },
  methods: {
    addRow (row) {
      this.items.push(row)
      this.item = {}
      let firstField = Object.keys(row)[0]
      let el = document.getElementById('field-' + firstField)
      el.focus()
      this.$emit('input', this.items)
    },
    delRow (index) {
      this.items.splice(index, 1)
    },
    setValues (row) {
      this.item = JSON.parse(JSON.stringify(row))
    }
  }
}
</script>
